import { useContext } from 'react'
import { useQuery } from 'react-query'
import { Container, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Spinner from '../../components/Spinner'

import { PlayerContext } from '../../pages/Home'
import RecordingList from '../../components/user/RecordingList'
import RecordingCarousel from '../../components/user/RecordingCarousel'
import { getPlaylistRecordingList } from '../../api/api.cdlbt.co'

const DiscoverSection = ({ alias, title, viewMore }) => {
  const { playRecordings } = useContext(PlayerContext)
  const playlist = useQuery({
    queryKey: ['playlist', alias],
    queryFn: getPlaylistRecordingList,
  })

  if (playlist.isLoading || playlist.isError) {
    return (
      <>
        <Col className='ps-4 pe-4 pb-4 d-none d-md-block'>
          <div className='d-flex w-100 justify-content-between mt-3 mb-3'>
            <div>
              <h2 className='fw-bold d-inline'>{title}</h2>
            </div>
            <div>
              {viewMore && (
                <Link className='btn btn-outline-secondary' to={`/${alias}`}>
                  View More
                </Link>
              )}
            </div>
          </div>
          <Container fluid className='p-4 text-center'>
            <Spinner />
          </Container>
        </Col>
        <Col className='d-block d-md-none d-lg-none d-xl-none d-xxl-none'>
          <div className='d-flex w-100 justify-content-between mt-3 mb-3'>
            <div>
              <h1 className='fw-bold pe-3'>{title}</h1>
            </div>
            <div>
              {viewMore && (
                <Link className='btn btn-outline-secondary' to={`/${alias}`}>
                  View More
                </Link>
              )}
            </div>
          </div>
          <Container fluid className='p-4 text-center'>
            <Spinner />
          </Container>
        </Col>
      </>
    )
  }

  const recordingList = playlist.data.slice(0, 10)
  return (
    <>
      <Col className='ps-4 pe-4 pb-4 d-none d-md-block'>
        <div className='d-flex w-100 justify-content-between mt-3 mb-3'>
          <div>
            <h2 className='fw-bold d-inline'>{title}</h2>
          </div>
          <div>
            {viewMore && (
              <Link className='btn btn-outline-secondary ms-3' to={`/${alias}`}>
                View More
              </Link>
            )}
            <button
              className='btn btn-outline-secondary ms-3'
              onClick={() => playRecordings(playlist.data)}
            >
              Play All
            </button>
          </div>
        </div>
        <RecordingCarousel alias={alias} recordingList={recordingList} />
      </Col>
      <Col className='d-block d-md-none d-lg-none d-xl-none d-xxl-none'>
        <div className='d-flex w-100 justify-content-between mt-3 mb-3'>
          <div>
            <h1 className='fw-bold'>{title}</h1>
          </div>
          <div>
            {viewMore && (
              <Link className='btn btn-outline-secondary ms-3' to={`/${alias}`}>
                View More
              </Link>
            )}
          </div>
        </div>
        <RecordingList
          alias={alias}
          recordingList={recordingList.slice(0, 5)}
        />
      </Col>
    </>
  )
}
export default DiscoverSection
